export default __webpack_public_path__ + "images/e380bccc104b00b8e1c529a9bb135be9.png";